import { aggregationSeparator } from '../../../state/utils/constants';
import { CategoryType } from '../../../search.types';

export const MINIMUM_CATS_SHOWN_COUNT: number = 5;

export function restrictLabel(type: string) {
  return `Restreindre la recherche à « ${type} »`;
}

export function checkIfCategoryIsSelected(
  paths: Array<string>,
  aggregationsPaths: Array<string>,
) {
  return aggregationsPaths.includes(paths.join(aggregationSeparator));
}

/*
panes represent
- CA ✓
-- Paris ✓
--- Chambre 1 ✓
-- Nimes
*/

/**
 * Limit the visible number of categories displayed
 * @param panes  all the opened nodes of the tree as dictionnary
 * @example  {CA: true, Paris: true, Nimes: true}
 * @param aggregationsPaths  all the selected categories as array
 * @example  ['juridiction---CA', 'juridiction---CA---Paris', 'juridiction---CA---Paris']
 * @param paths  the path throw a node as array
 * @example  ['juridiction', 'CA']
 */
export function limitVisibility(
  panes: { [s: string]: boolean },
  aggregationsPaths: Array<string>,
  paths: Array<string>,
) {
  const key = paths[paths.length - 1];

  return (category: CategoryType, index: number): boolean =>
    index < MINIMUM_CATS_SHOWN_COUNT ||
    checkIfCategoryIsSelected(paths.concat(category.key), aggregationsPaths) ||
    panes[key];
}
